import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: true,
  base: 'osm-tiles',
  limitBounding: null,
  viewState: null,
  polygons: null,
  layers: null,
  tileservers: null,
  zones: [],
  interact: false,
  resetSelected: false,
  streetToPoint: false,
  pointStreet: [],
  addStreet: false,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setLoadMap: (state, action) => {
      state.loading = action.payload;
    },
    setBaseMap: (state, action) => {
      state.base = action.payload;
    },
    startResetSelected: (state) => {
      state.resetSelected = true;
    },
    stopResetSelected: (state) => {
      state.resetSelected = false;
    },
    setViewState: (state, action) => {
      state.viewState = action.payload;
    },
    setLimitBoundings: (state, action) => {
      state.limitBounding = action.payload;
    },
    setTileServ: (state, action) => {
      state.tileservers = action.payload;
    },
    setTileLayer: (state, action) => {
      state.layers = action.payload;
    },
    setPolygonsCity: (state, action) => {
      state.polygons = action.payload;
    },
    setZonesOfCity: (state, action) => {
      state.zones = action.payload;
    },
    setInteractMap: (state, action) => {
      state.interact = action.payload;
    },
    setAddStreet: (state, action) => {
      state.addStreet = action.payload;
    },
    setStreetToPoint: (state, action) => {
      state.streetToPoint = true;
      state.pointStreet = action.payload;
    },
    resetPointStreet: (state) => {
      state.streetToPoint = false;
      state.pointStreet = [];
    },
  },
});

export const {
  setLoadMap,
  setBaseMap,
  startResetSelected,
  stopResetSelected,
  setViewState,
  setLimitBoundings,
  setAddStreet,
  setTileServ,
  setTileLayer,
  setPolygonsCity,
  setZonesOfCity,
  setInteractMap,
  setStreetToPoint,
  resetPointStreet,
} = mapSlice.actions;

export default mapSlice.reducer;
